//  'numVms': 0
//  'numManaged': 0
//  'accountKey': 'DISCOVERY-122'
//  'numDetections': 32
//  'numProgressions': 0
//  'type': 'AWS'

const discoveryAccountsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Name',
        label: 'Name',
        sortable: true,
        'min-width': 150,
        name: 'nickName'
      },
      {
        datatype: 'string',
        description: 'Type',
        label: 'Type',
        sortable: true,
        'min-width': 100,
        name: 'source',
        display: 'icon',
        displayKey: [
          { key: 'AWS', icon: 'table-logos-icon logo-aws-color' },
          { key: 'AZURE', icon: 'table-logos-icon logo-only-azure-color' },
          { key: 'GCP', icon: 'table-logos-icon logo-only-gcp-color' }
        ]
      },
      {
        datatype: 'string',
        description: 'Found',
        label: 'Found',
        sortable: true,
        'min-width': 150,
        name: 'numVms',
        display: 'component',
        component: 'AssetCountTableCell',
        componentKey: 'numVms',
        componentFields: {
          vmCount: 'numVms',
          containerCount: 'numContainers',
          accountKey: 'accountKey',
          nickName: 'nickName'
        }
      },
      {
        datatype: 'string',
        description: 'Detections',
        label: 'Detections',
        sortable: true,
        'min-width': 150,
        name: 'numDetections',
        display: 'link',
        pathTo: 'account-iocs',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'accountKey'
          },
          {
            name: 'nickName',
            keyLookup: 'nickName'
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Progressions',
        label: 'Progressions',
        sortable: true,
        'min-width': 150,
        name: 'numProgressions',
        display: 'link',
        pathTo: 'account-progressions',
        query: [
          {
            name: 'accountKey',
            keyLookup: 'accountKey'
          },
          {
            name: 'nickName',
            keyLookup: 'nickName'
          }
        ]
      },
      {
        datatype: 'string',
        description: 'Sensor Coverage',
        label: 'Sensor Coverage',
        sortable: true,
        'min-width': 150,
        name: 'numVms',
        display: 'component',
        component: 'SensorCoverageTableCell',
        componentKey: 'numVms',
        componentFields: {
          completed: 'numManaged',
          total: 'numVms'
        }
      },
      {
        datatype: 'string',
        description: 'State',
        label: 'State',
        sortable: true,
        'min-width': 150,
        name: 'status',
        display: 'component',
        component: 'IntegrationStatusTableCell',
        componentKey: 'status',
        componentFields: {
          status: 'status',
          source: 'source',
          lastScanTime: 'lastOperationTime'
        }
      }
    ]
  }
}

export { discoveryAccountsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/integration_accounts/discovery-accounts.meta.js